import {useEffect, useState} from "react";
import {useClientConfig} from "../hooks/useClientConfig";
import {userService} from "../services";
import {getKeycloak} from "../services/api/interceptors";

const TABLEAU_SCRIPT_ID = "tableau-embedding-api";

const TableauViz = ({reportId, title}) => {
    const config = useClientConfig();
    const report = config?.tableau?.reports?.find(r => r.id === reportId);
    const scriptSrc = config?.tableau?.scriptSrc;
    const keycloak = getKeycloak();
    const userId = keycloak?.subject;

    const [isScriptReady, setIsScriptReady] = useState(false);
    const [hasScriptError, setHasScriptError] = useState(false);
    const [token, setToken] = useState(null);
    const [tokenError, setTokenError] = useState(false);

    useEffect(() => {
        const loadToken = async () => {
            try {
                if (keycloak?.authenticated) {
                    const tokenData = await userService.generateToken();
                    setToken(tokenData.token || tokenData);
                    setTokenError(false);
                }
            } catch (error) {
                console.error("Erreur lors de la génération du token Tableau : ", error);
                setTokenError(true);
            }
        };
        loadToken();
    }, [userId, keycloak?.authenticated]);

    useEffect(() => {
        if (!scriptSrc) return;

        const existingScript = document.getElementById(TABLEAU_SCRIPT_ID);
        if (existingScript) {
            setIsScriptReady(true);
            return;
        }

        const script = document.createElement("script");
        script.id = TABLEAU_SCRIPT_ID;
        script.src = scriptSrc;
        script.type = "module";
        script.async = true;
        script.onload = () => setIsScriptReady(true);
        script.onerror = () => setHasScriptError(true);

        document.head.appendChild(script);

        return () => {
            script.onload = null;
            script.onerror = null;
        };
    }, [scriptSrc]);

    if (!report?.vizSrc) {
        return (
            <div className="page-content">
                <h1>{title || "Reporting"}</h1>
                <p>Configuration du rapport manquante.</p>
            </div>
        );
    }

    return (
        <div className="page-content" style={{display: "flex", flexDirection: "column", height: "100vh", overflow: "hidden"}}>
            {hasScriptError && <p>Impossible de charger l'API Tableau.</p>}
            {tokenError && <p>Impossible de générer le token Tableau.</p>}
            {!hasScriptError && !tokenError && !isScriptReady && <p>Chargement du reporting...</p>}

            {isScriptReady && token && (
                <tableau-viz
                    token={token}
                    id={`tableau-viz-${reportId}`}
                    src={report.vizSrc}
                    width="100%"
                    height="100%"
                    toolbar="bottom"
                    style={{display: "flex", flex: 1}}
                />
            )}
        </div>
    );
};

export default TableauViz;